import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject, Subject, takeUntil, tap, withLatestFrom } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

const PLACEHOLDER_IMAGE_URL = '/assets/images/horse-placeholder.png';
const FULLSCREEN_EL_ID = 'fullscreenpicture';
const DISMISS_FULLSCREEN_FN = (): void => document.getElementById(FULLSCREEN_EL_ID).remove();
declare const jwplayer: any;

@Component({
  selector: 'app-video-viewer',
  templateUrl: './video-viewer-modal.component.html',
  styleUrls: ['./video-viewer-modal.component.scss']
})
export class VideoViewerModalComponent implements OnInit, OnDestroy {
  @Input() public title!: string;
  @Input() public attachmentUrl!: string | SafeResourceUrl;
  @Input() public isVideo!: boolean;
  @Input() public action!: string;
  @Input() public jwPlayerId!: string;
  private _onDestroy$: Subject<void> = new Subject<void>();
  public _showOnFullscreen$: Subject<void> = new Subject<void>();

  public attachmentUrl$: BehaviorSubject<string | SafeResourceUrl> = new BehaviorSubject<
    string | SafeResourceUrl>(PLACEHOLDER_IMAGE_URL);
  public action$: BehaviorSubject<string> = new BehaviorSubject<string>('Close');
  public title$: BehaviorSubject<string> = new BehaviorSubject<string>('Preview');
  public urlSafe: SafeResourceUrl;

  constructor(
    private _modalCtrl: ModalController,
    private _sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    if (this.attachmentUrl) {
      this.attachmentUrl$.next(this.attachmentUrl);
    }

    if (this.action) {
      this.action$.next(this.action);
    }

    if (this.title) {
      this.title$.next(this.title);
    }

    // initialize JWPlayer when jwPlayerId is available
    if (this.jwPlayerId) {
      this.urlSafe = this.getJWplayerUrl(this.jwPlayerId);
    }

    this._showOnFullscreen$
      .pipe(
        takeUntil(this._onDestroy$),
        withLatestFrom(this.attachmentUrl$),
        tap(([_, url]) => {
          const img: HTMLIonImgElement = document.createElement('ion-img');
          img.id = FULLSCREEN_EL_ID;
          img.src = url as string;
          img.onclick = DISMISS_FULLSCREEN_FN;
          img.style.position = 'fixed';
          img.style.top = '0px';
          img.style.bottom = '0px';
          img.style.left = '0px';
          img.style.right = '0px';
          img.style.backgroundColor = 'gainsboro';
          document.body.appendChild(img);
        })
      )
      .subscribe();
    
    // jwplayer('player').setup({
    //   title: 'Ride Media',
    //   playlist: `https://cdn.jwplayer.com/v2/media/${this.jwPlayerId}`,
    //   mute: true,
    //   autostart: true,
    //   primary: 'html5',
    //   stretching: 'full'
    // });
  }

  public dismiss(value?: any): void {
    this._modalCtrl.dismiss(value);
  }

  public ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  public accept(): void {
    this.dismissModal(true);
  }

  public showOnFullscreen(): void {
    this._showOnFullscreen$.next();
  }

  public dismissModal(confirm: boolean = false): void {
    this._modalCtrl.dismiss(confirm);
  }

  public getJWplayerUrl(jwPlayerId) {
    const url = this._sanitizer.bypassSecurityTrustResourceUrl(
      'https://content.jwplatform.com/players/' + jwPlayerId + '.html'
    );
    return url;
  }
}
